import LegalPage from "./LegalPage";
const Security = () => <LegalPage docKey="security" />;
export default Security;
